import React from "react";
import { theme } from "antd";
import { useColorMode } from "../../../contexts/color-mode";
import { hexToRgba } from "../../../shared/styles";

export const AccountShowStyles: React.FC = () => {
  const { mode } = useColorMode();
  const isDark = mode === "dark";
  const { token } = theme.useToken();

  return (
    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');

      * {
        box-sizing: border-box;
      }

      button:hover {
        transform: translateY(-1px);
      }

      a:hover {
        opacity: 0.8;
      }

      .ant-table {
        background: transparent !important;
      }

      .ant-table-thead > tr > th {
        background: ${isDark ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.02)"} !important;
        color: ${isDark ? "rgba(255,255,255,0.6)" : "rgba(0,0,0,0.6)"} !important;
        border-bottom: 1px solid ${isDark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.06)"} !important;
        padding: 14px 24px !important;
        font-size: 13px;
        font-weight: 500;
        letter-spacing: 0.3px;
      }

      .ant-table-thead > tr > th:first-child {
        padding-left: 28px !important;
      }

      .ant-table-thead > tr > th:last-child {
        padding-right: 28px !important;
      }

      .ant-table-tbody > tr > td {
        border-bottom: 1px solid ${isDark ? "rgba(255,255,255,0.04)" : "rgba(0,0,0,0.04)"} !important;
        color: ${isDark ? "rgba(255,255,255,0.85)" : "rgba(0,0,0,0.85)"} !important;
        padding: 16px 24px !important;
      }

      .ant-table-tbody > tr > td:first-child {
        padding-left: 28px !important;
      }

      .ant-table-tbody > tr > td:last-child {
        padding-right: 28px !important;
      }

      .ant-table-tbody > tr:last-child > td {
        border-bottom: none !important;
      }

      .ant-table-tbody > tr:hover > td {
        background: ${isDark ? "rgba(255,255,255,0.02)" : "rgba(0,0,0,0.02)"} !important;
      }

      .ant-table-wrapper .ant-pagination {
        padding: 16px 28px !important;
        margin: 0 !important;
        border-top: 1px solid ${isDark ? "rgba(255,255,255,0.04)" : "rgba(0,0,0,0.04)"};
      }

      .ant-empty-description {
        color: ${isDark ? "rgba(255,255,255,0.4)" : "rgba(0,0,0,0.4)"} !important;
      }

      .ant-pagination-item a {
        color: ${isDark ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.7)"} !important;
      }

      .ant-pagination-item-active {
        background: ${hexToRgba(token.colorPrimary, 0.2)} !important;
        border-color: ${hexToRgba(token.colorPrimary, 0.4)} !important;
      }

      .ant-spin-dot-item {
        background-color: ${token.colorPrimary} !important;
      }

      .refine-page-header {
        background: transparent !important;
        padding: 0 !important;
      }
    `}</style>
  );
};
